import { useMemo } from 'react';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { Color } from './types';

export const useColorMap = () => {
  const { colors } = useSiteConfig();
  const cmsColors = colors?.colors as Color[];

  return useMemo(() => {
    const map: { [key: string]: string } = {};
    if (Array.isArray(cmsColors)) {
      cmsColors.forEach((color) => {
        if (color.name && color.hex) {
          map[color.name.toLowerCase()] = color.hex;
        }
      });
    }
    return map;
  }, [cmsColors]);
};

export const useIconMap = () => {
  const icons = useSiteConfig()?.colors?.icons;

  return useMemo(() => {
    const map: { [key: string]: string } = {};
    if (Array.isArray(icons)) {
      icons.forEach((icon) => {
        if (icon.title && icon.filename) {
          map[icon.title.toLowerCase()] = icon.filename;
        }
      });
    }
    return map;
  }, [icons]);
};
